/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import Select from '@react/react-spectrum/Select';
import FlagIcon from './flagIcon';
import { setCSSProperty, addClass, removeClass } from '../../utils/cssUtils';

const POPOVER_CLASS = 'country-select-popover';

export default class CountrySelect extends React.Component {
    constructor(props) {
        super(props);
        const { value } = props;
        this.state = {
            country: value,
        };
    }

    componentWillMount() {
        window.addEventListener('resize', this.windowResizeListener.bind(this));
    }


    componentWillReceiveProps(nextProps) {
        const phoneInputCompts = document.getElementsByClassName('react-phone-number-input__input');
        if (phoneInputCompts && phoneInputCompts[0].value) {
            this.setState({ country: nextProps.value });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResizeListener.bind(this));
    }

    onCountryChange(inputCountry) {
        const { onChange } = this.props;
        if (onChange) {
            onChange(inputCountry);
        }
        this.setState({ country: inputCountry });
    }


    setPopoverHeight() {
        const popoverElem = document.getElementsByClassName(POPOVER_CLASS)[0];
        if (popoverElem) {
            const targetHeight = popoverElem.style['max-height'];
            setCSSProperty(popoverElem, 'height', targetHeight, 'important');
            setCSSProperty(popoverElem, 'min-width', '15rem', 'important');
        }
    }

    getCountryLabel(option) {
        if (option.value) {
            switch (option.value.toLowerCase()) {
            case 'hk':
                return 'Hong Kong SAR of China';
            case 'cn':
                return 'China';
            case 'tw':
                return 'Taiwan region';
            case 'mo':
                return 'Macau SAR of China';
            default:
                return option.label;
            }
        }
        return option.label;
    }

    // Set overflow -> hidden for root div in ccweb
    setRootOverflowClass(bool) {
        const root = document.getElementById('root');
        if (bool) {
            addClass(root, 'setOverflowHidden');
        } else {
            removeClass(root, 'setOverflowHidden');
        }
    }

    selectOpen() {
        setTimeout(() => {
            addClass(document.getElementsByClassName('country-select-menu')[0].parentNode, POPOVER_CLASS);
            this.setPopoverHeight();
        }, 0);
    }

    windowResizeListener() {
        const self = this;
        if (typeof this.timerResize !== 'undefined') {
            clearTimeout(this.timerResize);
        }
        this.timerResize = setTimeout(() => {
            self.setPopoverHeight();
        }, 20);
    }

    render() {
        const finalOptions = [];
        const { options } = this.props;
        const { country } = this.state;
        options.forEach((option) => {
            const Icon = option.icon;
            finalOptions.push({
                label: this.getCountryLabel(option),
                value: option.value,
                icon: option.value
                    ? <FlagIcon flagId={option.value} country={option.label} />
                    : <Icon />,
            });
        });
        return (
            <Select
                aria-label="Country"
                className="country-select"
                options={finalOptions}
                value={country}
                onOpen={this.selectOpen.bind(this)}
                onChange={this.onCountryChange.bind(this)}
                onClick={() => this.setRootOverflowClass(true)}
                onClose={() => this.setRootOverflowClass(false)}
                quiet
                menuClassName="country-select-menu" />
        );
    }
}
